<template>
    <div>
        <fusioncharts
            type="stackedbar2d"
            width="100%"
            height="400"
            @dataplotrollover="highlightUnit"
            @dataplotrollout="dehighlightUnit"
            :dataSource="dataSource">
        </fusioncharts>
    </div>
</template>

<script>
    export default {
        props: {
            data: {
                type: [Array, Object],
                required: true
            },

            isSite: {
                type: Boolean,
                required: false
            }
        },

        methods: {
            highlightUnit(e) {
                this.$emit('unitSelected', e.data);
            },

            dehighlightUnit() {
                this.$emit('unitdeSelected');
            },

            characterRange(startChar, endChar) {
                return String.fromCharCode(..._.range(startChar.charCodeAt(0), endChar.charCodeAt(0) + 1)).split('').reverse()
            }
        },

        computed: {
            dataSource() {
                return {
                    chart: {
                        theme: "fusion",
                        showBorder: 1,
                        borderColor: "#cbd5e1",
                        canvasRightPadding: 10,
                        caption: "Building Occupancy",
                        subCaption: "By Floor",
                        captionFontColor: "#000000",
                        subCaptionFontColor: "#000000",
                        xAxisname: "Floor",
                        yAxisMaxValue: this.yAxisMaxValue,
                        yAxisName: "Square Footage",
                        showSum: "0",
                        interactiveLegend: "0",
                        baseFontSize: 16,
                        decimals: 1,
                        xAxisNameFontColor: "#000000",
                        yAxisNameFontColor: "#000000",
                    },
                    categories: this.categories,
                    dataset: this.datasets,
                }
            },

            buildingFloors() {
                var numericBuildingFloors = _.map(_.range(0, this.topFloor), (num) => {
                    return num + 1;
                }).reverse()

                if (this.nonNumericBuildingFloors.length) {
                    if (this.nonNumericBuildingFloors[0] != "LL") {
                        return _.concat(numericBuildingFloors, this.characterRange("A", this.nonNumericBuildingFloors[0]))
                    }

                    return _.concat(numericBuildingFloors, this.nonNumericBuildingFloors);
                }

                return numericBuildingFloors;
            },

            nonNumericBuildingFloors() {
                return _.filter(_.keys(this.data), (key) => { return ! parseInt(key) }).sort().reverse();
            },

            categories() {
                return [{
                    category:
                        _.map(this.buildingFloors, (floor) => {
                            return {
                                'label': floor.toString()
                            }
                        })
                }];
            },

            dataSetNames() {
                if (this.isSite) {
                    return [
                        { color: '#085394', name: 'Your Space' },
                        { color: '#1f9d55', name: 'Available' },
                        { color: '#DAE1E7', name: 'Occupied' },
                    ]
                }

                return [
                    { color: '#1f9d55', name: 'Available' },
                    { color: '#DAE1E7', name: 'Occupied' },
                ]
            },

            datasets() {
                return _.map(this.dataSetNames, (dataset, key) => {
                    return {
                        color: dataset.color,
                        seriesName: dataset.name.toUpperCase(),
                        data:
                            _.map(this.buildingFloors, (value, key) => {
                                if (this.data[value] != undefined) {
                                    return {
                                        'value': this.data[value][dataset.name] ? this.data[value][dataset.name] : 0
                                    }
                                }

                                return {
                                    'value': 0
                                }
                            })
                    }
                })
            },

            yAxisMaxValue() {
                return _.max(_.map(_.map(this.data, _.values), _.sum));
            },

            topFloor() {
                return _.maxBy(_.keys(this.data), function(key) { return isNaN(parseInt(key)) ? key : parseInt(key); });
            }
        },
    }
</script>
